import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'

import { useAppSelector } from '~/store/hooks'

import { Badge } from '../UI/Badge'
import { toggleSidebar } from './sidebar-actions'

const SidebarItem: React.FC<SidebarItemProps> = ({
  name,
  icon: Icon,
  to,
  href,
  childPaths,
  badgeColor,
  badgeText,
  hasChildren
}) => {
  const location = useLocation()
  const { pathname } = location

  const getSidebarItemClass = useCallback(() => {
    if (to === '/') {
      return pathname === to ? 'active' : ''
    }

    if (
      pathname.startsWith(to) ||
      childPaths?.some(childPath => pathname.startsWith(childPath))
    ) {
      return 'active'
    }

    return ''
  }, [childPaths, pathname, to])

  const getChildrenClass = hasChildren ? 'hasChildren' : ''
  /**
   * Toggle mobile menu
   */

  const dispatch = useDispatch()

  const {
    layout: { isMobile }
  } = useAppSelector(state => state)

  const handleToggleSidebar = useCallback(() => {
    dispatch(toggleSidebar())
  }, [dispatch])

  const mobileLinkProps = isMobile ? { onClick: handleToggleSidebar } : {}

  const linkContent = (
    <>
      {Icon ? <Icon size={12} className="align-middle me-2" /> : null}
      {name}
      {badgeText && <Badge template={badgeColor}>{badgeText}</Badge>}
    </>
  )

  return (
    <li
      className={`sidebar-item sidebar-item-without-children ${getSidebarItemClass()}`}
    >
      {href ? (
        <a
          href={href}
          className={`sidebar-link ${getChildrenClass}`}
          style={{ textDecoration: 'none' }}
          target="_blank"
          rel="noopener noreferrer"
          {...mobileLinkProps}
        >
          {linkContent}
        </a>
      ) : (
        <NavLink
          to={to}
          className={`sidebar-link ${getChildrenClass}`}
          style={{ textDecoration: 'none' }}
          end="active"
          {...mobileLinkProps}
        >
          {linkContent}
        </NavLink>
      )}
    </li>
  )
}

export default SidebarItem
